import React, { useState, useEffect } from 'react';
import {
  Box,
  Paper,
  Typography,
  Tabs,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Chip,
  IconButton,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Grid,
  Card,
  CardContent,
  Avatar,
  Stack,
  Tooltip,
  Alert,
  Link,
  Snackbar,
  CircularProgress,
  Checkbox,
  FormControlLabel
} from '@mui/material';
import {
  CheckCircle as ApproveIcon,
  Cancel as RejectIcon,
  Visibility as ViewIcon,
  Comment as CommentIcon,
  FilterList as FilterIcon,
  Refresh as RefreshIcon
} from '@mui/icons-material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers';
import axios from 'axios';
import { format } from 'date-fns';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

const formatEmployeeName = (emp) => {
  if (!emp) return "Unknown"
  
  const first = emp.firstName ? String(emp.firstName).trim() : ""
  const last = emp.lastName ? String(emp.lastName).trim() : ""
  
  const parts = []
  if (first && first.toLowerCase() !== "null" && first.toLowerCase() !== "undefined") parts.push(first)
  if (last && last.toLowerCase() !== "null" && last.toLowerCase() !== "undefined") parts.push(last)
  
  if (parts.length > 0) {
    return parts.join(" ")
  }
  
  const rawName = emp.name || emp.fullName || "Unknown"
  if (rawName === "Unknown") return "Unknown"
  
  const cleaned = rawName.split(" ")
    .filter(s => s && s.toLowerCase() !== 'null' && s.toLowerCase() !== 'undefined')
    .join(" ")
    .trim()
    
  return cleaned || "Unknown"
}

const TimesheetApproval = () => {
  const [tabValue, setTabValue] = useState(0);
  const [timesheets, setTimesheets] = useState([]);
  const [loading, setLoading] = useState(true);
  const [pagination, setPagination] = useState({
    page: 0,
    limit: 10,
    total: 0,
    totalPages: 0
  });
  const [stats, setStats] = useState({
    pending: 0,
    approved: 0,
    rejected: 0,
    total: 0,
    employees: 0
  });
  const [selectedTimesheet, setSelectedTimesheet] = useState(null);
  const [openViewDialog, setOpenViewDialog] = useState(false);
  const [openRejectDialog, setOpenRejectDialog] = useState(false);
  const [rejectComment, setRejectComment] = useState('');
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'success'
  });
  const [selectedTimesheets, setSelectedTimesheets] = useState([]);
  const [bulkActionDialog, setBulkActionDialog] = useState(false);
  const [bulkActionType, setBulkActionType] = useState('');
const [employeeId,setEmployeeId]=useState();
  // Status tabs mapping
  const tabs = [
    { label: 'Pending', value: 'Pending' },
    { label: 'Approved', value: 'Approved' },
    { label: 'Rejected', value: 'Rejected' }
  ];
  useEffect(() => {
    const fetchEmployeeId = async () => {
      try {
        const token = localStorage.getItem('token');
        let empId = '';
        if (token) {
          try {
            const payload = JSON.parse(atob(token.split('.')[1]));
            empId = payload.employee_id || '';
          } catch (e) {}
        }
        if (!empId) {
          const response = await axios.get(`${API_URL}/api/user/current`, {withCredentials: true});
          empId = response.data.employee_id || "";
        }
        setEmployeeId(empId);
      } catch (err) {
        //console.error("Failed to fetch employee ID from session:", err);
      }
    };
  
    fetchEmployeeId();
  }, []);

  useEffect(() => {
    if (employeeId) {
      fetchStats();
      fetchTimesheets();
    }
  }, [employeeId, tabValue, pagination.page, pagination.limit]);

  const fetchStats = async () => {
    try {
      const response = await axios.get(`${API_URL}/api/tsheet-approval/stats?employee_id=${employeeId}`, {
        headers:{
          Authorization: `Bearer ${localStorage.getItem('token')}`
        },
        withCredentials: true
      });
      if (response.data.success) {
        setStats(response.data.data);
      }
    } catch (error) {
      //console.error('Error fetching stats:', error);
    }
  };

  const fetchTimesheets = async () => {
    setLoading(true);
    try {
      const status = tabs[tabValue]?.value;
      const response = await axios.get(`${API_URL}/api/tsheet-approval/?employee_id=${employeeId}`, {
        params: {
          status: status,
          page: pagination.page + 1,
          limit: pagination.limit
        },
        withCredentials: true,
headers:{
          Authorization: `Bearer ${localStorage.getItem('token')}`
        },
            });       

      if (response.data.success) {
        setTimesheets(response.data.data);
        setPagination({
          page: response.data.pagination.page - 1,
          limit: response.data.pagination.limit,
          total: response.data.pagination.total,
          totalPages: response.data.pagination.totalPages
        });
        setSelectedTimesheets([]); // Clear selection on data change
      }
    } catch (error) {
      //console.error('Error fetching timesheets:', error);
      showSnackbar('Failed to fetch timesheets', 'error');
    } finally {
      setLoading(false);
    }
  };

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
    setPagination(prev => ({ ...prev, page: 0 }));
  };

  const handlePageChange = (event, newPage) => {
    setPagination(prev => ({ ...prev, page: newPage }));
  };

  const handleRowsPerPageChange = (event) => {
    setPagination(prev => ({
      ...prev,
      limit: parseInt(event.target.value, 10),
      page: 0
    }));
  };

  const handleViewTimesheet = (timesheet) => {
    setSelectedTimesheet(timesheet);
    setOpenViewDialog(true);
  };

  const handleApprove = async (timesheetId) => {
    try {
      const response = await axios.put(
        `${API_URL}/api/tsheet-approval/${timesheetId}/status?employee_id=${employeeId}`,
        { status: 'Approved' },
        { withCredentials: true,
             headers:{
          Authorization: `Bearer ${localStorage.getItem('token')}`
        },
         }
      );

      if (response.data.success) {
        showSnackbar('Timesheet approved successfully', 'success');
        fetchTimesheets();
        fetchStats();
      }
    } catch (error) {
      //console.error('Error approving timesheet:', error);
      showSnackbar('Failed to approve timesheet', 'error');
    }
  };

  const handleReject = async () => {
    if (!rejectComment.trim()) {
      showSnackbar('Please provide a reason for rejection', 'warning');
      return;
    }

    try {
      const response = await axios.put(
        `${API_URL}/api/tsheet-approval/${selectedTimesheet.timesheet_id}/status?employee_id=${employeeId}`,
        { 
          status: 'Rejected',
          review_comments: rejectComment
        },
        { withCredentials: true,
             headers:{
          Authorization: `Bearer ${localStorage.getItem('token')}`
        },
         }
      );

      if (response.data.success) {
        showSnackbar('Timesheet rejected successfully', 'success');
        setOpenRejectDialog(false);
        setRejectComment('');
        setSelectedTimesheet(null);
        fetchTimesheets();
        fetchStats();
      }
    } catch (error) {
      //console.error('Error rejecting timesheet:', error);
      showSnackbar('Failed to reject timesheet', 'error');
    }
  };

  const handleBulkAction = async () => {
    if (selectedTimesheets.length === 0) {
      showSnackbar('Please select timesheets to process', 'warning');
      return;
    }

    try {
      const response = await axios.post(
        `${API_URL}/api/tsheet-approval/bulk-update?employee_id=${employeeId}`,
        {
          timesheet_ids: selectedTimesheets,
          status: bulkActionType,
          review_comments: bulkActionType === 'Rejected' ? 'Bulk rejected' : null
        },
        { withCredentials: true,
             headers:{
          Authorization: `Bearer ${localStorage.getItem('token')}`
        },
         }
      );

      if (response.data.success) {
        showSnackbar(response.data.message, 'success');
        setBulkActionDialog(false);
        setSelectedTimesheets([]);
        fetchTimesheets();
        fetchStats();
      }
    } catch (error) {
      //console.error('Error in bulk action:', error);
      showSnackbar('Failed to process bulk action', 'error');
    }
  };

  const showSnackbar = (message, severity) => {
    setSnackbar({ open: true, message, severity });
  };

  const handleSelectAll = (event) => {
    if (event.target.checked) {
      setSelectedTimesheets(timesheets.map(t => t.timesheet_id));
    } else {
      setSelectedTimesheets([]);
    }
  };

  const handleSelectOne = (event, id) => {
    const selectedIndex = selectedTimesheets.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = [...selectedTimesheets, id];
    } else {
      newSelected = selectedTimesheets.filter(item => item !== id);
    }

    setSelectedTimesheets(newSelected);
  };

  const getStatusChip = (status) => {
    const colors = {
      Pending: { bg: '#fff3e0', color: '#ed6c02' },
      Approved: { bg: '#e8f5e8', color: '#2e7d32' },
      Rejected: { bg: '#ffebee', color: '#c62828' },
      Resubmitted: { bg: '#e3f2fd', color: '#0d47a1' }
    };

    return (
      <Chip
        label={status}
        size="small"
        sx={{
          backgroundColor: colors[status]?.bg || '#f5f5f5',
          color: colors[status]?.color || '#000',
          fontWeight: 500
        }}
      />
    );
  };
  const getGoogleMapsLink = (lat, lng) => {
    if (!lat || !lng) return null;
    return `https://www.google.com/maps?q=${lat},${lng}`;
  };
  
  // Format location display
  const formatLocation = (lat, lng) => {
    if (!lat || !lng) return '-';
    
    return (
      <Link
        href={getGoogleMapsLink(lat, lng)} 
        target="_blank" 
        rel="noopener"
        sx={{ display: 'flex', alignItems: 'center' }}
      >
        {lat}, {lng}
      </Link>
    );
  };
  return (
    <Box sx={{ p: 3 }}>
      {/* Header */}
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Typography variant="h4" fontWeight="bold">
          Timesheet Approval
        </Typography>
        <Box>
          <Tooltip title="Refresh">
            <IconButton onClick={fetchTimesheets} sx={{ mr: 1 }}>
              <RefreshIcon />
            </IconButton>
          </Tooltip>
          {selectedTimesheets.length > 0 && (
            <>
              <Button
                variant="contained"
                color="success"
                startIcon={<ApproveIcon />}
                onClick={() => {
                  setBulkActionType('Approved');
                  setBulkActionDialog(true);
                }}
                sx={{ mr: 1 }}
              >
                Approve ({selectedTimesheets.length})
              </Button>
              <Button
                variant="contained"
                color="error"
                startIcon={<RejectIcon />}
                onClick={() => {
                  setBulkActionType('Rejected');
                  setBulkActionDialog(true);
                }}
              >
                Reject ({selectedTimesheets.length})
              </Button>
            </>
          )}
        </Box>
      </Box>

      {/* Stats Cards */}
      <Grid container spacing={3} sx={{ mb: 3 }}>
        <Grid item xs={12} sm={6} md={3}>
          <Card>
            <CardContent>
              <Typography color="textSecondary" gutterBottom>
                Team Members
              </Typography>
              <Typography variant="h4">{stats.employees}</Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Card sx={{ bgcolor: '#fff3e0' }}>
            <CardContent>
              <Typography color="textSecondary" gutterBottom>
                Pending
              </Typography>
              <Typography variant="h4">{stats.pending}</Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Card sx={{ bgcolor: '#e8f5e8' }}>
            <CardContent>
              <Typography color="textSecondary" gutterBottom>
                Approved
              </Typography>
              <Typography variant="h4">{stats.approved}</Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Card sx={{ bgcolor: '#ffebee' }}>
            <CardContent>
              <Typography color="textSecondary" gutterBottom>
                Rejected
              </Typography>
              <Typography variant="h4">{stats.rejected}</Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      {/* Tabs */}
      <Paper sx={{ mb: 2 }}>
             <Tabs
          value={tabValue}
          onChange={handleTabChange}
          indicatorColor="primary"
          textColor="primary"
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
        >
          {tabs.map((tab, index) => (
            <Tab 
              key={index} 
              label={`${tab.label} (${stats[tab.label.toLowerCase()] || 0})`} 
            />
          ))}
        </Tabs>

      </Paper>

      {/* Timesheets Table */}
      <Paper>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow sx={{ bgcolor: '#f5f5f5' }}>
                {tabValue === 0 && ( // Only show checkbox for pending tab
                  <TableCell padding="checkbox">
                    <Checkbox
                      indeterminate={selectedTimesheets.length > 0 && selectedTimesheets.length < timesheets.length}
                      checked={timesheets.length > 0 && selectedTimesheets.length === timesheets.length}
                      onChange={handleSelectAll}
                    />
                  </TableCell>
                )}
                <TableCell>Employee</TableCell>
                <TableCell>Date</TableCell>
                <TableCell>Task</TableCell>
                <TableCell>Hours</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {loading ? (
                <TableRow>
                  <TableCell colSpan={tabValue === 0 ? 8 : 7} align="center" sx={{ py: 3 }}>
                    <CircularProgress />
                  </TableCell>
                </TableRow>
              ) : timesheets.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={tabValue === 0 ? 8 : 7} align="center" sx={{ py: 3 }}>
                    <Typography color="textSecondary">
                      No {tabs[tabValue]?.label.toLowerCase()} timesheets found
                    </Typography>
                  </TableCell>
                </TableRow>
              ) : (
                timesheets.map((timesheet) => (
                  <TableRow key={timesheet.timesheet_id} hover>
                    {tabValue === 0 && (
                      <TableCell padding="checkbox">
                        <Checkbox
                          checked={selectedTimesheets.includes(timesheet.timesheet_id)}
                          onChange={(e) => handleSelectOne(e, timesheet.timesheet_id)}
                        />
                      </TableCell>
                    )}
                    <TableCell>
                      <Stack direction="row" spacing={1} alignItems="center">
                        <Avatar sx={{ width: 32, height: 32, bgcolor: 'primary.main' }}>
                          {formatEmployeeName(timesheet.employee)?.charAt(0) || 'U'}
                        </Avatar>
                        <Box>
                          <Typography variant="body2">{formatEmployeeName(timesheet.employee)}</Typography>
                          <Typography variant="caption" color="textSecondary">
                            {timesheet.employee?.employee_id}
                          </Typography>
                        </Box>
                      </Stack>
                    </TableCell>
                    <TableCell>
                      {timesheet.date ? format(new Date(timesheet.date), 'dd/MM/yyyy') : '-'}
                    </TableCell>
                    <TableCell>
                      {timesheet.issue?.title || timesheet.task_name || '-'}
                    </TableCell>
                    <TableCell>
                      <Chip 
                        label={`${timesheet.hours_worked} hrs`}
                        size="small"
                        color={timesheet.is_overtime ? 'warning' : 'default'}
                      />
                    </TableCell>
                    <TableCell>{getStatusChip(timesheet.status)}</TableCell>
                    <TableCell>
                      <Stack direction="row" spacing={1}>
                        <Tooltip title="View Details">
                          <IconButton
                            size="small"
                            onClick={() => handleViewTimesheet(timesheet)}
                          >
                            <ViewIcon fontSize="small" />
                          </IconButton>
                        </Tooltip>
                        {timesheet.status === 'Pending' && (
                          <>
                            <Tooltip title="Approve">
                              <IconButton
                                size="small"
                                color="success"
                                onClick={() => handleApprove(timesheet.timesheet_id)}
                              >
                                <ApproveIcon fontSize="small" />
                              </IconButton>
                            </Tooltip>
                            <Tooltip title="Reject">
                              <IconButton
                                size="small"
                                color="error"
                                onClick={() => {
                                  setSelectedTimesheet(timesheet);
                                  setOpenRejectDialog(true);
                                }}
                              >
                                <RejectIcon fontSize="small" />
                              </IconButton>
                            </Tooltip>
                          </>
                        )}
                      </Stack>
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>

        {/* Pagination */}
        <TablePagination
          component="div"
          count={pagination.total}
          page={pagination.page}
          onPageChange={handlePageChange}
          rowsPerPage={pagination.limit}
          onRowsPerPageChange={handleRowsPerPageChange}
          rowsPerPageOptions={[5, 10, 25, 50]}
        />
      </Paper>

      {/* View Details Dialog */}
      <Dialog
        open={openViewDialog}
        onClose={() => setOpenViewDialog(false)}
        maxWidth="md"
        fullWidth
      >
        {selectedTimesheet && (
          <>
            <DialogTitle>
              Timesheet Details
              <Typography variant="subtitle2" color="textSecondary">
                ID: {selectedTimesheet.timesheet_id}
              </Typography>
            </DialogTitle>
            <DialogContent dividers>
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <Typography variant="subtitle2" color="textSecondary">
                    Employee
                  </Typography>
                  <Typography variant="body1" gutterBottom>
                    {formatEmployeeName(selectedTimesheet.employee)}
                  </Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography variant="subtitle2" color="textSecondary">
                    Date
                  </Typography>
                  <Typography variant="body1" gutterBottom>
                    {selectedTimesheet.date ? format(new Date(selectedTimesheet.date), 'dd MMMM yyyy') : '-'}
                  </Typography>
                </Grid>
               
                <Grid item xs={6}>
                  <Typography variant="subtitle2" color="textSecondary">
                    Hours Worked
                  </Typography>
                  <Typography variant="body1" gutterBottom>
                    {selectedTimesheet.hours_worked} hrs
                    {selectedTimesheet.is_overtime && (
                      <Chip label="Overtime" size="small" color="warning" sx={{ ml: 1 }} />
                    )}
                  </Typography>
                </Grid>
               <Grid item xs={6}>
  <Typography variant="subtitle2" color="textSecondary">
    Location
  </Typography>

  <Typography variant="body2">
    {formatLocation(selectedTimesheet.latitude, selectedTimesheet.longitude)}
  </Typography>
</Grid>
              
                {selectedTimesheet.issue && (
                  <Grid item xs={12}>
                    <Typography variant="subtitle2" color="textSecondary">
                      Issue/Task
                    </Typography>
                    <Typography variant="body1" gutterBottom>
                      {selectedTimesheet.issue.title} ({selectedTimesheet.issue.issue_key})
                    </Typography>
                  </Grid>
                )}
                <Grid item xs={12}>
                  <Typography variant="subtitle2" color="textSecondary">
                    Description
                  </Typography>
                  <Paper variant="outlined" sx={{ p: 2, bgcolor: '#f9f9f9' }}>
                    <Typography variant="body2">
                      {selectedTimesheet.description}
                    </Typography>
                  </Paper>
                </Grid>
                {selectedTimesheet.location_address && (
                  <Grid item xs={12}>
                    <Typography variant="subtitle2" color="textSecondary">
                      Location
                    </Typography>
                    <Typography variant="body2">
                      {selectedTimesheet.location_address || 
                       (selectedTimesheet.latitude && selectedTimesheet.longitude 
                         ? `${selectedTimesheet.latitude}, ${selectedTimesheet.longitude}`
                         : 'Location not available')}
                    </Typography>
                    
                  </Grid>
                )}
                {selectedTimesheet.review_comments && (
                  <Grid item xs={12}>
                    <Typography variant="subtitle2" color="textSecondary">
                      Review Comments
                    </Typography>
                    <Paper variant="outlined" sx={{ p: 2, bgcolor: '#ffebee' }}>
                      <Typography variant="body2">
                        {selectedTimesheet.review_comments}
                      </Typography>
                    </Paper>
                  </Grid>
                )}
              </Grid>
            </DialogContent>
            <DialogActions>
              <Button onClick={() => setOpenViewDialog(false)}>Close</Button>
            </DialogActions>
          </>
        )}
      </Dialog>

      {/* Reject Dialog */}
      <Dialog
        open={openRejectDialog}
        onClose={() => {
          setOpenRejectDialog(false);
          setRejectComment('');
          setSelectedTimesheet(null);
        }}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Reject Timesheet</DialogTitle>
        <DialogContent>
          <Typography variant="body2" color="textSecondary" sx={{ mb: 2 }}>
            Please provide a reason for rejecting this timesheet
          </Typography>
          <TextField
            autoFocus
            label="Rejection Reason"
            multiline
            rows={4}
            fullWidth
            value={rejectComment}
            onChange={(e) => setRejectComment(e.target.value)}
            placeholder="Enter the reason for rejection..."
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => {
            setOpenRejectDialog(false);
            setRejectComment('');
            setSelectedTimesheet(null);
          }}>
            Cancel
          </Button>
          <Button
            variant="contained"
            color="error"
            onClick={handleReject}
            disabled={!rejectComment.trim()}
          >
            Reject
          </Button>
        </DialogActions>
      </Dialog>

      {/* Bulk Action Confirmation Dialog */}
      <Dialog
        open={bulkActionDialog}
        onClose={() => setBulkActionDialog(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          {bulkActionType === 'Approved' ? 'Approve' : 'Reject'} Multiple Timesheets
        </DialogTitle>
        <DialogContent>
          <Typography variant="body1" gutterBottom>
            Are you sure you want to {bulkActionType.toLowerCase()} {selectedTimesheets.length} selected timesheets?
          </Typography>
          {bulkActionType === 'Rejected' && (
            <Typography variant="body2" color="textSecondary" sx={{ mt: 2 }}>
              Note: No individual rejection reasons will be added. Consider rejecting individually if specific reasons are needed.
            </Typography>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setBulkActionDialog(false)}>Cancel</Button>
          <Button
            variant="contained"
            color={bulkActionType === 'Approved' ? 'success' : 'error'}
            onClick={handleBulkAction}
          >
            Confirm {bulkActionType}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Snackbar for notifications */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      >
        <Alert
          onClose={() => setSnackbar({ ...snackbar, open: false })}
          severity={snackbar.severity}
          sx={{ width: '100%' }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default TimesheetApproval;